import type { BoundLocalePicker } from '@affine/core/hooks/use-locale-picker';

export interface MarketplaceChangelogSource {
  changelog: string;
  changelogI18n?: Record<string, string> | null;
}

function normalizeChangelogMap(
  value: Record<string, unknown>
): Record<string, string> | null {
  const out: Record<string, string> = {};
  for (const [locale, text] of Object.entries(value)) {
    if (typeof text === 'string' && text.trim().length > 0) {
      out[locale] = text.trim();
    }
  }
  return out.de && out.en ? out : null;
}

export function getMarketplaceChangelogMap(
  source: MarketplaceChangelogSource
): Record<string, string> {
  if (source.changelogI18n) {
    const normalized = normalizeChangelogMap(source.changelogI18n);
    if (normalized) return normalized;
  }

  const scalar = source.changelog.trim();
  if (scalar.startsWith('{')) {
    try {
      const parsed = JSON.parse(scalar) as unknown;
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        const normalized = normalizeChangelogMap(
          parsed as Record<string, unknown>
        );
        if (normalized) return normalized;
      }
    } catch {
      // Keep rendering the scalar below.
    }
  }

  return scalar ? { de: scalar, en: scalar } : {};
}

export function pickMarketplaceChangelog(
  source: MarketplaceChangelogSource,
  picker: BoundLocalePicker | null
): string {
  const map = getMarketplaceChangelogMap(source);
  return picker?.pickDescription(map) ?? map.en ?? map.de ?? '';
}
